module.exports = __webpack_public_path__ + "img/guide_03.9d5db2e6.png";